import Vue from 'vue';
import Vuex from 'vuex';

import glModule from './modules/global';
import navModule from './modules/navigation';
import compModule from './modules/competition';
import setModule from './modules/settings';

import glAction from './actions/global';

Vue.use(Vuex);

 const store = new Vuex.Store({
    modules: {
        glModule,
        navModule,
        compModule,
        setModule,
    }
});

store.dispatch(`${glAction.CONNECT}`);

export default store;